import React from 'react';
import {useAuthenticated} from 'react-admin';
import AppBar from "../../Components/header/index";
// import Footer from "../../Components/Footer/index";
// import MenteeProfile  from "../../Components/MenteeProfile/index"
import AppProvider from "./../../Components/bootstrap"
import CardContent from '@material-ui/core/CardContent';
// import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';


export default function Home(state) {
    const data=state.location.state
    useAuthenticated()
// const {match:{params}}=this.props

    return (
        <AppProvider>
            <AppBar/>
            <div>
            <Card>
                <CardContent>
                {data !==  '' ?
                <div style={{marginTop:50,marginLeft:100}}>
                        <Typography>Mentor Details</Typography>
                        <Typography>Name:</Typography>
                        <div ><label  style={{fontSize:15,marginTop:3}}>{data.name}</label><br/></div>
                        <Typography>Contact Number</Typography>
                        <div ><label  style={{fontSize:15,marginTop:3}}>{data.contactNo}</label><br/></div>
                        <Typography>Specialization</Typography>
                        <div ><label  style={{fontSize:15,marginTop:3}}>{data.specialization}</label><br/></div>
                        <Typography>Email</Typography>
                        <div ><label  style={{fontSize:15,marginTop:3}}>{data.email}</label><br/></div>
                        <Typography>Taxes</Typography>
                        <div ><label  style={{fontSize:15,marginTop:3}}>{data.taxes}</label><br/></div>
                        <Typography>BasePrice</Typography>
                        <div ><label  style={{fontSize:15,marginTop:3}}>{data.basePrice}</label><br/></div>
                        <Typography>InternetProcessing</Typography>
                        <div ><label  style={{fontSize:15,marginTop:3}}>{data.internetProcessing}</label><br/></div>
                </div>
                :
                <div>
                    <label style={{fontSize:15,marginTop:3}}>No Users Assigned</label>
                </div>
                }  
                </CardContent>
            </Card>
            </div>
         </AppProvider>
    );
}
